// Vendor libraries
import cloneDeep from 'lodash.clonedeep';
// Constants
import { ASC } from 'NewAngular/constants/core.constants';
import { FolderCollectionViewSortColumn } from 'FoldersApp/enums/folder-views.enums';
// Services
import { FolderOperationsService } from './folder-operations.service';
// Utils
import { formFlattenedObject } from 'NewAngular/utils/urls';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "./folder-operations.service";
export class FolderCollectionService extends FolderableCollectionServiceBase {
    constructor(folderOperationsService) {
        super();
        this.folderOperationsService = folderOperationsService;
        this.FOLDER_COLLECTION_PARAMS_DEFAULT = {
            owner: { me: true, shared_with_me: true, public: true },
            sortColumn: FolderCollectionViewSortColumn.MODIFY_DATE,
            sortDirection: ASC,
            name: '',
            viewDepth: 4,
            viewRootFolder: null,
            includeEmptyFolders: true,
        };
        this.dataParams = cloneDeep(this.FOLDER_COLLECTION_PARAMS_DEFAULT);
    }
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.FOLDER_COLLECTION_PARAMS_DEFAULT));
        return this.folderOperationsService.getFolders(dataParams);
    }
}
FolderCollectionService.ɵfac = function FolderCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderCollectionService)(i0.ɵɵinject(i1.FolderOperationsService)); };
FolderCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FolderCollectionService, factory: FolderCollectionService.ɵfac });
